import React, { useContext, useEffect, useState } from 'react'
import { Context } from 'Context/Context';
import ListElement, { QUEUE_GRID } from '../Element/ListElement';
import { Pagination } from './Analytics/AdminAnalyticsUI';

// Design 19b - admin approval queue (To verify / Profile updates / Firm switches)
const PAGE_SIZE = 20;
const HEAD = ['', 'Name', 'Email', 'Firm', 'Website', 'Actions'];

function ApprovalQueue({ apiUrl, title, subtitle, emptyText = 'Nothing awaiting approval' }) {
  const { makeApiCallFunc } = useContext(Context);
  const [approveList, setApproveList] = useState();
  const [updateList, setUpdateList] = useState(false);
  const [skip, setSkip] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    makeApiCallFunc(apiUrl,
      { skip, limit: PAGE_SIZE },
      ({data}) => {
        window.scrollTo(0, 0);
        setApproveList(data?.users || []);
        setTotalCount(data?.totalCount || 0);
      },
      (error) => { console.log(error); setApproveList([]); }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateList, skip, apiUrl]);

  // if the last row on a page was approved/denied, step back a page
  useEffect(() => {
    if (approveList && approveList.length === 0 && skip > 0) setSkip(Math.max(0, skip - PAGE_SIZE));
  }, [approveList, skip]);

  const page = Math.floor(skip / PAGE_SIZE) + 1;
  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));
  const from = totalCount === 0 ? 0 : skip + 1;
  const to = Math.min(skip + PAGE_SIZE, totalCount);

  return (
    <div className='w-full min-h-full font-plexsans px-4 py-6 lg:px-10 lg:py-[34px]' style={{ background: '#f7f4ed' }}>
      <h2 style={{ margin: '0 0 4px', font: "400 19px/1.3 'Spectral',serif", color: '#14213d' }}>{title}</h2>
      <p style={{ margin: '0 0 24px', fontSize: '13px', lineHeight: 1.5, color: 'rgba(20,33,61,.5)' }}>{subtitle}</p>

      {approveList === undefined ?
        <div style={{ fontSize: '13px', color: 'rgba(20,33,61,.45)' }}>Loading…</div>
      : approveList.length === 0 ?
        <div className='bg-white flex items-center justify-center text-center' style={{ border: '1px solid rgba(20,33,61,.12)', borderRadius: '6px', padding: '56px 16px', fontSize: '13px', color: 'rgba(20,33,61,.5)' }}>
          {emptyText}
        </div>
      :
        <>
          <div className='bg-white' style={{ border: '1px solid rgba(20,33,61,.12)', borderRadius: '6px', overflow: 'hidden' }}>
            <div className='overflow-x-auto'>
              <div style={{ minWidth: '820px' }}>
                <div className='grid' style={{ gridTemplateColumns: QUEUE_GRID, background: '#14213d' }}>
                  {HEAD.map((h, i) => (
                    <div key={i} style={{ padding: '13px 16px', font: "600 10.5px/1.2 'IBM Plex Mono',monospace", textTransform: 'uppercase', letterSpacing: '.06em', color: 'rgba(247,244,237,.75)', textAlign: i === HEAD.length - 1 ? 'right' : 'left' }}>{h}</div>
                  ))}
                </div>
                {approveList.map((item, key) => (
                  <ListElement key={item?._id || key} item={item} setUpdateList={setUpdateList} keyVal={key + skip + 1} />
                ))}
              </div>
            </div>
            {totalPages > 1 && <Pagination page={page} totalPages={totalPages} onPage={(p) => { if (p >= 1 && p <= totalPages) setSkip((p - 1) * PAGE_SIZE); }} />}
          </div>
          <div style={{ marginTop: '14px', fontSize: '12px', color: 'rgba(20,33,61,.45)' }}>Showing {from}–{to} of {totalCount}</div>
        </>
      }
    </div>
  )
}

export default ApprovalQueue
